import {CollateralMovement} from "../PortfolioCollateral";
import {ObjectUtil} from "../../../../../js/util/ObjectUtil";
import {CollateralTableRow} from "./CollateralTable";
import {UnlodgedCollateral} from "../../../../../types/PortfolioMarginResult";
import {Optional} from "../../../../../js/util/Optional";

export class UnlodgedTableRow implements CollateralTableRow<UnlodgedCollateral> {

    private calculatedRow: UnlodgedCollateral;

    public constructor(private unlodged?: UnlodgedCollateral,
                       public pendingUnlodge?: CollateralMovement,
                       public pendingLodge?: CollateralMovement) {
        this.calculateActualRowValue();
    }

    private calculateActualRowValue() {
        if (this.unlodged != null && this.pendingUnlodge == null && this.pendingLodge == null) {
            this.calculatedRow = ObjectUtil.copy(this.unlodged);
            this.calculatedRow.haircut = 1 - this.calculatedRow.haircut;
        } else if (this.unlodged != null && (this.pendingUnlodge != null || this.pendingLodge != null)) {
            this.calculatedRow = this.mergeValues(this.unlodged, this.pendingUnlodge, this.pendingLodge);
            this.calculatedRow.haircut = 1 - this.calculatedRow.haircut;
        } else if (this.pendingUnlodge != null && this.pendingLodge == null) {
            this.calculatedRow = this.createUnlodgeRow(this.pendingUnlodge);
        } else if (this.pendingLodge != null && this.unlodged == null) {
            throw Error("Pending Lodge with no unlodged amount available");
        } else {
            throw Error("Unable to create a row from two null values");
        }
    }

    private mergeValues(unlodged: UnlodgedCollateral,
                        pending?: CollateralMovement,
                        pendingLodge?: CollateralMovement): UnlodgedCollateral {
        const pendingLodgeQuantity = Optional.of(pendingLodge)
                                             .map(pl => pl.quantity)
                                             .orElse(0);
        const pendingUnlodgeQuantity = Optional.of(pending)
                                               .map(p => p.quantity)
                                               .orElse(0);
        const copy = ObjectUtil.copy(unlodged);
        copy.quantity = copy.quantity + pendingUnlodgeQuantity - pendingLodgeQuantity;
        const totalValue = copy.quantity * copy.price;
        copy.value = totalValue * copy.haircut;
        return copy;
    }

    private createUnlodgeRow(pending: CollateralMovement): UnlodgedCollateral {
        const value = pending.price * pending.quantity;
        const haircutValue = value * (1 - pending.haircut);
        return {
            securityCode: pending.code,
            price: pending.price,
            quantity: pending.quantity,
            haircut: pending.haircut,
            value: haircutValue
        };
    }

    public get code(): string {
        return this.calculatedRow.securityCode;
    }

    public get pending(): CollateralMovement | undefined {
        return this.pendingLodge || this.pendingUnlodge;
    }

    public get hasPending(): boolean {
        return this.pending != null;
    }

    public get data(): UnlodgedCollateral {
        return this.calculatedRow;
    }
}
